// Generated from App.tsx for a single page build. Do not edit.
// Generated by the server from the registered pages. Do not edit.
import { Routes, Route, useLocation } from 'react-router-dom';
import OrganizationStructurePage from "../pages/OrganizationStructure/OrganizationStructure";
const __wvcRoutePaths = ["/OrganizationStructurePage", "/co-cau-to-chuc"];
function AppRoutes() {
  const location = useLocation();
  const owned = new Set(["404", "aboutpage", "businessareaspage", "co-cau-to-chuc", "contactpage", "gioi-thieu", "homepage", "lien-he", "linh-vuc-hoat-dong", "newsandeventspage", "organizationstructurepage", "post", "presidentbiographypage", "search", "tieu-su-chu-tich-hoi-pham-van-khiem", "tin-tuc-su-kien", "trang-chu"]);
  const segment = (location.pathname.split('/')[1] || '').toLowerCase();
  return <Routes key={owned.has(segment) ? segment : '/'}>
      
      
      
      <Route path={__wvcRoutePaths[0]} element={<OrganizationStructurePage />} />
      
      
      
      
      
      
      
      
      
      <Route path={__wvcRoutePaths[1]} element={<OrganizationStructurePage />} />
      
      
      
      
    </Routes>;
}
function App() {
  return <>
      <AppRoutes />
    </>;
}
export default App;
